import React from "react";
import { isMobile } from "react-device-detect";
// import agendaimg from '../../public/img/agenda.png'

const WorkshopPage = () => {
    return (
        <section className="workshop-section">
            <div className="workshop-container">
                <div className="workshop-image">
                    <div className="workshop-title"><h2>WORKSHOPS</h2></div>
                    <img
                        src={isMobile ? '/img/workshop-mob.png' : '/img/workshop-desk.png'}
                        alt="Workshop"

                    />
                    <img
                        src={'/img/workshop-reg-btn.png'}
                        alt="Workshop"
                        id="workshop-reg-btn"
                        onClick={()=>{window.open('https://docs.google.com/forms/d/e/1FAIpQLSfcybpWjgM-9S0E6Tai6Lov5I0gPBEb4BfrOnJ6555eumqwEw/viewform','_blank')}}
                    />

                </div>
            </div>
        </section>
    );
};

export default WorkshopPage;